<script setup>
  import TerritorioSelectorPanel from './TerritorioSelectorPanel.vue';
  import TabView from 'primevue/tabview';
  import TabPanel from 'primevue/tabpanel';
  import { ref, defineEmits, defineProps, computed } from "vue";

  const emit = defineEmits(["update:modelValue", "refresh"]);
  const props = defineProps({
    modelValue: {
      type: Array,
      default: [],
    },
  });

  const territorios = computed({
    get: () => props.modelValue,
    set: (val) => emit("update:modelValue", val)
  });

  const selectTerritorio = (territorio) => {
    if (territorios.value.includes(territorio)) {
      territorios.value = territorios.value.filter((t) => t !== territorio);
    } else {
      territorios.value = [...territorios.value, territorio];
    }
    emit("refresh");
  };

  const changeTab = (e) => {

    // if (e === 1) {
    //   trabajo.setTodos();
    // } else {
    //   trabajo.getIniciados();
    // }
  };
  // fecha 6 meses atras
  const start = new Date(new Date().setMonth(new Date().getMonth() - 1));
  // console.log("start", start)
  
</script>

<template>
  
<TabView :lazy="true" @update:activeIndex="changeTab">
  <TabPanel :header="`Todos`">
    <TerritorioSelectorPanel :start="start" :selected="territorios" @selected="selectTerritorio" />
  </TabPanel>
    <TabPanel :header="`Incompletos`">
       <TerritorioSelectorPanel :onlyIncomplete="true" :start="start" :selected="territorios" @selected="selectTerritorio" />
    </TabPanel>
    <!-- <TabPanel header="Header III"></TabPanel> -->
</TabView>
</template>

<style>
.territorio {
  border: 1px solid #ccc;
  text-align: center;
  cursor: pointer;
}
.territorio {
  padding: 1rem;
  min-width: 10rem;
}

h2, h4, p {
  margin: 0; 
}
h5 {
  margin: 0.5rem 0; 
}

</style>